import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";

import { Breadcrumbs } from "~/components/admin/Breadcrumbs";
import { UsersIcon } from "~/components/admin/Icons";
import { PageHeader } from "~/components/admin/PageHeader";
import { UsersTable } from "~/components/admin/UsersTable";
import { QueryState } from "~/components/QueryState";
import { TRPCClientErrorDisplay } from "~/components/TRPCClientErrorDisplay";
import { Spinner } from "~/components/ui/Spinner";
import { useTRPC } from "~/lib/trpc";

export const Route = createFileRoute("/_authenticated/admin/users/")({
  component: UsersIndex,
});

function UsersIndex() {
  const trpc = useTRPC();
  const query = useQuery(trpc.users.list.queryOptions());

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={
          <Breadcrumbs>
            <Link to="/admin">Admin</Link>
            <span>Users</span>
          </Breadcrumbs>
        }
        icon={UsersIcon}
        title="Goose Users"
      />
      <QueryState
        result={query}
        loading={
          <div className="flex justify-center items-center py-24">
            <Spinner size="lg" />
          </div>
        }
        error={(error) => <TRPCClientErrorDisplay error={error} />}
      >
        {(data) => <UsersTable data={data} />}
      </QueryState>
    </div>
  );
}
